import { useClientStore } from "@/store/client";
import { useContextStore } from "@/store/context";

export const useContainerFidelite = () => {
  const { layout } = storeToRefs(useContextStore());
  const { setPopinAjoutCarteVisible, setRefreshCards, setPopinAjoutCarteContexte: setCardContext } = useClientStore();
  const setPopinAjoutCarte = (context = "addCard") => {
    setPopinAjoutCarteVisible(true);
    setCardContext(context);
    setRefreshCards(true)
  }

  return {
    layout,
    setPopinAjoutCarte
  }
}